module.exports = __webpack_public_path__ + "static/media/Group 33080.c2cc3bbf.png";